import React from 'react';
import { QuickViewModalProps } from './QuickViewModal.types';
import {
  Title,
  Container,
  Message,
  StyledModal,
  TitleContainer,
} from './QuickViewModal.styles';
import Button from '../../forms/Button';
import { modalStyle } from '../../forms/common.styles';

const QuickViewModal = ({ isOpen, onClose }: QuickViewModalProps) => {
  return (
    <StyledModal isOpen={isOpen} style={modalStyle} onRequestClose={onClose}>
      <Container>
        <TitleContainer>
          <Title>Quick Quote Enabled</Title>
        </TitleContainer>
        <Message>
          You’re being redirected to Quick Quote — a faster way to create orders
          and purchases. To return to the standard order form, simply turn off
          the toggle.
        </Message>
        <Button title='Ok' size='medium' textColor='white' onClick={onClose} />
      </Container>
    </StyledModal>
  );
};

export default QuickViewModal;
